import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  extend, useLazyDataModel, params, string, arrayOf, shape, number, customType
} from '@thd-nucleus/data-sources';

export const useAddNewIntentsProject = ({ projectId, projectRefetch }) => {
  const [createIntentsProject] = useLazyDataModel('addIntentsToProject', {
    variables: {
      projectId,
    },
    skip: !projectId,
    context: { withAuth: true },
    fetchPolicy: 'no-cache'
  });

  const handleCreateNewIntents = async (currentIntents) => {
    try {
      const itemsToAdd = currentIntents.map((grpIntent) => {
        return {
          groupName: grpIntent.groupName,
          items: grpIntent.materials.map((item) => ({
            description: item.intent,
            quantity: item.quantity
          }))
        };
      });
      await createIntentsProject({
        variables: {
          intents: itemsToAdd,
        }
      });
      await projectRefetch();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Error creating new intents in project:', error);
    }
  };

  return {
    handleCreateNewIntents,
  };
};

useAddNewIntentsProject.propTypes = {
  projectId: PropTypes.string.isRequired,
  projectRefetch: PropTypes.func.isRequired
};

useAddNewIntentsProject.dataModel = extend(
  {
    addIntentsToProject: params({
      projectId: string().isRequired(),
      intents: arrayOf(customType('CreateIntentInput').shape({
        groupName: string().isRequired(),
        items: arrayOf(shape({
          description: string().isRequired(),
          quantity: number().isRequired()
        }).isRequired()).isRequired()
      }).isRequired()).isRequired()
    }).mutation().shape({
      projectId: string()
    })
  }
);
